// extracted by mini-css-extract-plugin
export var closeButton = "_2m-3";
export var header = "_2m-0";
export var link = "_2m-1";
export var retryButton = "_2m-2";